"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

import { EntitySubtitle, EntityTitle } from "./EntityTitle";

export type PlaceholderSectionProps = {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  iconClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
};

export function PlaceholderSection({
  icon,
  title,
  description,
  children,
  className,
  contentClassName,
  iconClassName,
  titleClassName,
  descriptionClassName,
}: PlaceholderSectionProps) {
  return (
    <div className={cn("flex items-center justify-center px-6 py-8", className)}>
      <div className={cn("w-full max-w-xs text-center", contentClassName)}>
        {icon ? (
          <div
            className={cn(
              "mx-auto mb-3 flex justify-center text-muted-foreground/60",
              iconClassName,
            )}
          >
            {icon}
          </div>
        ) : null}
        <EntityTitle
          as="h2"
          size="sm"
          className={cn("text-center", titleClassName)}
        >
          {title}
        </EntityTitle>
        {description ? (
          <EntitySubtitle
            as="p"
            tone="muted"
            className={cn(
              "mt-1 text-center text-caption leading-relaxed",
              descriptionClassName,
            )}
          >
            {description}
          </EntitySubtitle>
        ) : null}
        {children ? <div className="mt-6">{children}</div> : null}
      </div>
    </div>
  );
}
